import { Component, OnInit, ElementRef, Directive, HostListener } from "@angular/core";
import { AbstractControl, FormGroup, FormControl, Validators, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { FirestoreService } from "src/app/services/firestore.service";
import { HttpService } from "src/app/services/http.service";
import { UtilService } from "src/app/services/util.service";
import { environment } from 'src/environments/environment';
import Swal from "sweetalert2";

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})

export class ForgetPasswordComponent implements OnInit {

  loginForm: FormGroup;
  passwordIsValid = false;
  hide : boolean = true;

  checked :any= 'email';
  id: any;
  enteredEmail: any;
  enteredOtp: any;

  constructor(
    private router: Router,
    private cookie: CookieService,
    private http: HttpService,
    private util: UtilService,
    public formBuilder: FormBuilder,
    private element: ElementRef,
    private fs: FirestoreService

  ) {


    this.loginForm = this.formBuilder.group({
      useremail: [null, [Validators.required, Validators.email]],
      // password: [null, [Validators.required, Validators.minLength(8)]],
      // confirmpassword: [null, [Validators.required]],
      // otpField:[null,[Validators.required,Validators.minLength(6)]]
    }
    // , { validator: this.pwdConfirming('password', 'confirmpassword') }
    );

  }
loader:any
  ngOnInit() {
this.util.showLoader$.subscribe(res=>{
 this.loader=res
})
  }

 pwdConfirming(key: string, confirmationKey: string) {
    return (group: FormGroup) => {
     const input = group.controls[key];
     const confirmationInput = group.controls[confirmationKey];

     if (!input.value || !confirmationInput.value) return null;
     if (!input.value.match(/\d/)) {
       return input.setErrors({ hasNumber: true });
      }
      else if (!input.value.match(/[A-Z]/)) {
       return input.setErrors({ hasCapitalCase: true });
     }
      else if (!input.value.match(/[a-z]/)) {
       return input.setErrors({ hasLowerCase: true });
      }
      else if (!input.value.match(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)) {
        return input.setErrors({ hasSpecialCharacters: true });
      }

    if (input.value !== confirmationInput.value) {
        return confirmationInput.setErrors({ notEquivalent: true });
      }

   };
  }

  login(data: any) {
    this.util.setLoaderValue(true);
if(data.value.useremail!=null){
  this.enteredEmail=data.value.useremail
    if (this.checked=='email') {
      // let json = {
      //   userid: data.value.useremail,
      // };
      // let params = {
      //   category: "USERS",
      //   conditions: [
      //     {
      //       key: "email",
      //       symbol: "==",
      //       value: data.value.useremail
      //     }
      //   ]
      // }
     
      // this.fs.getData(params).subscribe((response: any) => {;
      //   if (response.status == "success") {
      //     if (response.data.length == 1) {
      //       this.checked = "otpField";
      //         let json = { emailId: this.enteredEmail };
      //         this.fs.getRequestOTPUser(json).subscribe((response:any)=>{
      //           if(response.status=='success'){
      //             this.util.setLoaderValue(false);
      //           this.util.showSnakbarMessage(
      //             "success",
      //             "OTP Sent to mail",
      //             "end",
      //             "top"
      //           );
      //           }
      //         },(err:any)=>{
      //           this.util.setLoaderValue(false);
      //           Swal.fire("Connection Issue, Try again After Sometimes");
      //         }) 
      //       this.id = response.data[0].id;
      //     } else if (response.data.length == 0) {
      //     this.util.showSnakbarMessage("error", "User name does not exists.", "end", "top");
      //     }
      //   }
      let formObj={
        productId:environment.productId,
        email:'',
        }
        formObj['email']=data.value.useremail
        let body={
          encrypted:''
        }
       body['encrypted'] =this.util.encrypt(formObj)
       let endPoint='passwordRecovery';
      this.http.blpAuthentication(body,endPoint).subscribe((res:any)=>{
        let result= JSON.parse(this.util.decrypt(res['encrypted']))
        if(result.status=='success'){
          this.util.showSnakbarMessage('success',result.message,'end','top')
          this.router.navigate(['login'])
        }
        else{
          this.util.showSnakbarMessage('error','User Not Found','end','top')
        }
      },(err:any)=>{
              this.util.setLoaderValue(false);
              Swal.fire("Connection Issue, Try again After Sometimes")});

    } 
    this.util.setLoaderValue(false);
              
  }
//   if (this.checked === 'otpField' && data.value.otpField!=null) {
//     this.util.setLoaderValue(true)
//     this.enteredOtp = this.loginForm.controls['otpField'].value;
//     let json = { emailId: this.enteredEmail, otp: this.enteredOtp };
//     if(json){
//     this.fs.verifyUserMAilOTP(json).subscribe((res:any) => {
//       if (res.status == 'success') {
//         this.util.setLoaderValue(false)
//         this.util.showSnakbarMessage(
//           "success",
//           "Verification is completed",
//           "end",
//           "top"
//         );
//         if (this.checked === 'otpField') {
//           this.checked = 'password'
//         }
//       }
//       else {
//         this.util.setLoaderValue(false);
//         this.util.showSnakbarMessage(
//           "error",
//           "Enter the correct OTP",
//           "end",
//           "top"
//         );
//       }
//     },(err:any)=>{
//       this.util.setLoaderValue(false);
//       Swal.fire("Connection Issue, Try again After Sometimes")})
//   }
// }
//   if(this.checked=='password') {
//     this.util.setLoaderValue(true);
//       let json = {
//         id: this.id,
//         userid: data.value.useremail,
//         password: data.value.password,
//         update: "password"
//       };

//       let updateData = { documentId: this.id, password: data.value.password,clientId:"VECV" };
//       this.fs.passwordUpdate(updateData).subscribe((response: any) => {
//         if (response.status == "success") {
//           this.util.setLoaderValue(false);
//           this.router.navigateByUrl("login");
//          this.util.showSnakbarMessage("success", "User password updated successfully!", "end", "top");
//         } else {
//           this.util.setLoaderValue(false);
//         this.util.showSnakbarMessage("error", "User password update failed", "end", "top");
//         }
//       }, (err) => {
//         console.error(err);
//         this.util.setLoaderValue(false);
//         this.util.showSnakbarMessage("error", "User password update failed", "end", "top");
//       });
//     }
  }
  resendOtp(loginForm){
      this.checked='email'
      this.login(loginForm)
  }
  passwordValid(event) {
    this.passwordIsValid = event;
  }
  passwordView() {
    this.hide = !this.hide;
  }
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
}
